import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import {useRef,useEffect,useState} from "react";
import Box from "@mui/material/Box";

import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Badge from '@mui/material/Badge';

import VerificationTablePagination from "./VerificationTablePagination";
import {Diagnoses} from "../../components/diagnoses";
import {VerificationImageItem} from "./VerificationImageItem";
import {getCurrentPageEntries, setCurrentPageEntries} from "./VerificationUtils";
import ImageListItemBar from "@mui/material/ImageListItemBar";
import VerificationCaseView from "./VerificationCaseView";


export default function VerificationImageList({imageIds, setDiagnose, prorodinkiService, diagnosis, setDiagnosis}) {
    // console.log('VerificationImageList started', imageIds)
    const imgWidth=200
    const listRef=useRef()
    const getCols = (width)=>parseInt((width-100)/(imgWidth+50))
    const [imageListCols, setImageListCols] = useState(getCols(window.innerWidth));
    const getNewSize = () => {
        setImageListCols(getCols(window.innerWidth))
        // console.log("imageListCols",getCols(window.innerWidth))
    };
    const [forceReloadPage, setForceReloadPage]= useState(false)
    const reloadPage = ()=>setForceReloadPage(!forceReloadPage)

    async function onRowsPerPageChange (e) {
        pageEntries.rowsPerPage = e.target.value
        await setCurrentPageEntries(pageEntries);
        // console.log('onRowsPerPageChange pageEntries:', pageEntries)
        reloadPage()
    }
    async function onPageNumberChange (e, newPage) {
        pageEntries.pageNumber = newPage
        await setCurrentPageEntries(pageEntries);
        // console.log('onPageChange pageEntries:', pageEntries)
        reloadPage()
    }
    const [pageData, setPageData] = useState([])

    const handleDiagnosisChange = (event) => {
        setDiagnosis(event.target.value);
    }
    useEffect(() => {
        window.addEventListener("resize", getNewSize);
    }, []);

    const pageEntries = getCurrentPageEntries()
    const lengthOf = (array)=>!!array? array.length: 0

    useEffect( () => {
            async function fetchPageCaseList(rowsPerPage, pageNumber) {
                // console.log('fetchPageCaseList started: ', rowsPerPage, pageNumber)

                if(lengthOf(imageIds)>0) {
                    let response = await prorodinkiService.getVerificationCasesPage(rowsPerPage, pageNumber)
                    // console.log('fetchPageCaseList returned:', response)

                    if (response.hasError) {
                        setPageData([])
                        //console.log('Error returned:', response.error)
                    } else {
                        setPageData(response.data)
                        // console.log('fetchPageCaseList',response.data)
                    }
                }
            }
            fetchPageCaseList(pageEntries.rowsPerPage, pageEntries.pageNumber)
        },
        [forceReloadPage]
    )

    const countCheckedItems = ()=>pageData.filter(el=>!!el.checkState).length
    const [checkedItemsNumber, setCheckedItemsNumber] = React.useState(countCheckedItems())
    const onCheckChange = ()=> {setCheckedItemsNumber(countCheckedItems())}
    const setCheckedDiagnoses = ()=>{
        setDiagnose(pageData.filter(el=>!!el.checkState).map(el=>el.id),Diagnoses[diagnosis].id)
    }
    const [viewCase, setViewCase] = useState(null)
    const [openVerificationCaseView, setOpenVerificationCaseView] = useState(false)
    const clickCase = (caseId) =>{
        setViewCase(pageData.find(el=>el.id===caseId))
        setOpenVerificationCaseView(true)
    }
    const closeVerificationCaseView = () =>{
        setOpenVerificationCaseView(false)
    }
    return (
        <Box sx={{ mx:5, mt:5}}>
            <Box sx={{mx:5, display:'flex', flexDirection:'row', alignItems:"flex-end", alignContent: 'flex-end'}}>

                <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
                    <InputLabel id="select-diagnose-label">Диагноз</InputLabel>
                    <Select
                        labelId="select-diagnose-label"
                        id="select-diagnose"
                        value={diagnosis}
                        onChange={handleDiagnosisChange}
                        label="Диагноз"
                        // disabled={countCheckedItems()===0}
                    >
                        <MenuItem key={-1} value={-1}>
                            <em>None</em>
                        </MenuItem>
                        {   Diagnoses.filter(diag=>diag.id!=='UNDEFINED').map((diag,index)=>(
                            <MenuItem key={index} value={index}>{diag.name}</MenuItem>))
                        }
                    </Select>
                </FormControl>

                <Badge badgeContent={countCheckedItems()} color="primary">
                    <Button sx={{ m: 1, minWidth: 100 }} style={{textTransform: 'capitalize'}} color='primary' variant="outlined" size={'small'}
                            disabled={ diagnosis<0} onClick={setCheckedDiagnoses}
                    >
                        {'Отправить'}
                    </Button>
                </Badge>
                {!!checkedItemsNumber ? null :
                    <VerificationTablePagination
                        pageEntries={pageEntries}
                        count={lengthOf(imageIds)}
                        onRowsPerPageChange={onRowsPerPageChange}
                        onPageChange ={onPageNumberChange}
                    />
                }
            </Box>
            <ImageList sx={{ width: "100%",  mx:5, mt:3, height: '100%',overflow: 'hidden'}} cols={imageListCols} ref={listRef}>
                {pageData.map((image) => (
                    <ImageListItem sx={{width:imgWidth, height:imgWidth, maxHeight: imgWidth+50}} key={image.fileName}>
                        <Card>
                            <VerificationImageItem item={image} imgWidth={imgWidth} onImageClick={clickCase} onCheckChange ={onCheckChange} />
                        </Card>
                        <ImageListItemBar
                            // title={<span>{`${diagNames[image.humanDiagData.diagnosis]}/${diagNames[image.neuralDiagnosis.diagnosis]}`}</span>}
                            subtitle={<span >{`${image.age}; ${image.sex? "Жен.": "Муж."}; ${image.location}; ${image.beginning}`}</span>}
                            position="below"
                        />
                    </ImageListItem>
                ))}
            </ImageList>
            <Box sx={{mr:10}}>
                {!!checkedItemsNumber  ? null :
                    <VerificationTablePagination
                        pageEntries={pageEntries}
                        count={lengthOf(imageIds)}
                        onRowsPerPageChange={onRowsPerPageChange}
                        onPageChange ={onPageNumberChange}
                    />
                }
            </Box>
            { !!viewCase?
                <VerificationCaseView
                    item={viewCase}
                    imgWidth = {500}
                    open={openVerificationCaseView}
                    handleClose={closeVerificationCaseView}
                />:null
            }
        </Box>
    );
}

